import { Error403 } from '@/components/blocks/errors/Error403/Error403';
import { Error404 } from '@/components/blocks/errors/Error404';
import { ErrorAlert } from '@/components/forms';
import { SkeletonBlock } from '@/components/general/skeletonBlock/SkeletonBlock';
import { ReactElement } from 'react';
import { FetchError, getErrorPhraseIds, getFetchErrors, isFetchError } from '@/utils';

interface QueryProps<T> {
    data: T;
    error: unknown | undefined;
    isLoading: boolean;
    children: (props: { data: NonNullable<T> }) => ReactElement;
    loaderComponent?: ReactElement;
    errorComponent?: ReactElement;
}

export const Query = <T = object,>(props: QueryProps<T>) => {
    if (props.error) return renderError(props.error, props.errorComponent);
    if (props.isLoading) return renderLoader(props.loaderComponent);
    return props.data ? props.children({ data: props.data }) : <></>;
};

const renderError = (err: FetchError | unknown, defaultErrComponent: ReactElement | undefined) => {
    if (isFetchError(err) && err.status === 404) {
        return <Error404 />;
    } else if (isFetchError(err) && err.status === 403) {
        const errorPhraseIds = getErrorPhraseIds(err);
        return <Error403 errorPhraseIds={errorPhraseIds} />;
    } else if (defaultErrComponent) {
        return defaultErrComponent;
    } else {
        return <ErrorAlert errorMessage={getFetchErrors(err)} />;
    }
};

const renderLoader = (loaderComponent: ReactElement | undefined) => {
    if (loaderComponent) return loaderComponent;
    return <SkeletonBlock />;
};
